import { render } from "./PersonalProjects.vue?vue&type=template&id=23e9c764&ts=true"
import script from "./PersonalProjects.vue?vue&type=script&lang=ts"
export * from "./PersonalProjects.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__